module.exports = __webpack_public_path__ + "static/media/level1_flag.ceb88878.svg";